const Strings = {
  token_jwt: "lajsndjkandkjnbsakj",
  default_photo:
    "https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg",
  load_image:"https://www.citypng.com/public/uploads/preview/loading-load-icon-transparent-png-701751695033022vy5stltzj3.png"
};

export default Strings;
